(function () {
    function makeDataTable(selector, dataPath, fields, orderby, order, display, bulk_actions, dom, opts) {
        var randNumber = Math.floor(Math.random() * 1000000 + 1);
        var id = "table_" + (opts?.id ?? randNumber);

        if (!window.pw_datatable_selected) {
            window.pw_datatable_selected = {};
            window.pw_datatable_select_all = {};
            window.pw_datatable_total_info = {};
        }

        window.pw_datatable_selected[id] = [];
        window.pw_datatable_select_all[id] = false;
        window.pw_datatable_total_info[id] = "";

        $(selector).html("<table id='" + id + "' class='table table-striped stripe'><thead><tr></tr></thead><tbody></tbody></table>");

        var aoColumns = [];
        var suppressColumns = ["edit", "view", "delete", "remove", "default", "revoke", "copy", "skip_installment", "pause"];
        $.each(fields, function (dbColumnName, tableHeader) {
            $("#" + id + " thead tr").append("<th>" + tableHeader + "</th>");

            if ($.inArray(dbColumnName, suppressColumns) === -1) {
                aoColumns.push({
                    name: dbColumnName,
                    data: dbColumnName,
                    responsivePriority: Object.keys(fields).indexOf(dbColumnName) === 0 ? 1 : 3,
                });
            } else {
                aoColumns.push({
                    name: dbColumnName,
                    data: dbColumnName,
                    sortable: false,
                    searchable: false,
                    responsivePriority: 2,
                });
            }
        });

        $(function () {
            if (window.pw_session) {
                dataPath += (dataPath.indexOf("?") > -1 ? "&" : "?") + "_session-token=" + window.pw_session;
            }
            var params = {
                sPaginationType: "full_numbers",
                ajax: dataPath, // path to DataTables
                processing: true, // process on server side
                serverSide: true, // process on server side
                stateSave: true, // save state between page views
                responsive: true, // make table responsive
                iDisplayLength: 25, // default results to show
                ordering: opts?.ordering ?? true,
                aoColumns: aoColumns,
                dom: 'fr<"H"l>Btip',
                buttons: [
                    {
                        text: window.pwtrans.table_export_csv,
                        action: function (e, dt, node, config) {
                            csvButton(e, dt, node, config, aoColumns, dataPath, "");
                        },
                    },
                ],
                oLanguage: {
                    sUrl:
                        window.location.hostname.lastIndexOf("app.", 0) === 0
                            ? ""
                            : window.pw_session
                            ? "/datatables-lang?_session-token=" + window.pw_session
                            : "/datatables-lang",
                    sEmptyTable: "There's no data to display here yet...",
                },
            };

            if (window.location.href.match(/\/(customers|promo-codes|tax)/)) {
                params.dom = 'Bfrt<"bottom"<"row"<"col-sm-4 col-xs-12"l><"col-sm-4 col-xs-12"i><"col-sm-4 col-xs-12"p>>><"clear">';
                params.buttons = [
                    "selectAll",
                    {
                        className: "all-rows",
                        action: function (e, dt, node, config) {
                            window.pw_datatable_select_all[id] = true;
                            $("button.buttons-select-all").click();
                            $(".all-rows").hide();
                        },
                    },
                    {
                        extend: "collection",
                        className: "drop",
                        text: 'Actions <span class="caret"></span>',
                        fade: 0,
                        buttons: [
                            {
                                text: "Export CSV",
                                action: function (e, dt, node, config) {
                                    csvButton(e, dt, node, config, aoColumns, dataPath, id);
                                },
                            },
                        ],
                    },
                ];
                if (window.location.href.indexOf("/customers") > -1) {
                    params.buttons[2].buttons.push({
                        text: "Create Invoices",
                        action: function (e, dt, node, config) {
                            var id = $(dt.body()).parent().attr("id");
                            if (!window.pw_datatable_select_all[id]) {
                                var selected = window.pw_datatable_selected[id];
                                selected = jQuery.map(selected, function (el) {
                                    return el.replace("dt", "");
                                });
                                window.location.href = "/send-invoice?customers=" + selected.join(",");
                            } else {
                                window.location.href = "/send-invoice?customers=all";
                            }
                        },
                    });
                    params.buttons[2].buttons.push({
                        text: "Subscribe to a plan",
                        action: function (e, dt, node, config) {
                            if (window.pw_datatable_selected[id].length > 0) {
                                if (!window.pw_datatable_select_all[id]) {
                                    var selected = window.pw_datatable_selected[id];
                                    selected = jQuery.map(selected, function (el) {
                                        return el.replace("dt", "");
                                    });
                                    $(".subs-title").text("Subscribe " + selected.length + " customers to a plan");
                                    $("#subs-ids").val(selected.join(","));
                                    $("#subscribe").modal();
                                }
                            } else {
                                Messenger().post("Please select customers!");
                            }
                        },
                    });
                    params.buttons[2].buttons.push({
                        text: "Delete Selected",
                        action: function (e, dt, node, config) {
                            var id = $(dt.body()).parent().attr("id");
                            if (!window.pw_datatable_select_all[id]) {
                                var selected = window.pw_datatable_selected[id];
                                selected = jQuery.map(selected, function (el) {
                                    return el.replace("dt", "");
                                });
                                dtBulkDelete(selected.join(","));
                            } else {
                                dtBulkDelete("all");
                            }
                        },
                    });
                }
                if (window.location.href.match(/\/(promo-codes|tax)/)) {
                    params.buttons[2].buttons.push({
                        text: "Delete Selected",
                        action: function (e, dt, node, config) {
                            var id = $(dt.body()).parent().attr("id");
                            if (!window.pw_datatable_select_all[id]) {
                                var selected = window.pw_datatable_selected[id];
                                selected = jQuery.map(selected, function (el) {
                                    return el.replace("dt", "");
                                });
                                dtBulkDelete(selected.join(","));
                            } else {
                                dtBulkDelete("all");
                            }
                        },
                    });
                }
                params.rowCallback = function (row, data, displayNum) {
                    if (data.DT_RowId && ($.inArray(data.DT_RowId, window.pw_datatable_selected[id]) !== -1 || window.pw_datatable_select_all[id])) {
                        $(row).find('input[type="checkbox"]').prop("checked", true);
                        $(row).addClass("selected");
                    }
                };
                params.infoCallback = function (settings, start, end, max, total, pre) {
                    window.pw_datatable_total_info[id] = total;
                    return "Showing " + start + " to " + end + " of " + total + " entries";
                };
            }

            if (typeof orderby !== "undefined" && typeof order !== "undefined") {
                params.order = [[orderby, order]];
            }

            if (typeof display !== "undefined" && display) {
                params.iDisplayLength = display;
            }

            if (typeof new_button !== "undefined") {
                params.oLanguage.sEmptyTable = new_button;
            }

            if (typeof bulk_actions !== "undefined" && bulk_actions) {
                params.buttons = params.buttons.concat(bulk_actions);
            }

            if (typeof dom !== "undefined" && dom) {
                params.dom = dom;
            }

            $("#" + id).on("xhr.dt", function (e, ins, json, xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                    return true;
                }
                if (!xhr.responseJSON && json === null && xhr.responseText) {
                    $.ajax({
                        url: "/ajax-error",
                        type: "POST",
                        data: {
                            error: "DataTables invalid JSON response",
                            response: xhr.responseText,
                            status: xhr.status,
                            request_url: dataPath,
                        },
                    });
                }
            });

            //render data to table
            var randNumber = $("#" + id).DataTable(params);

            //select all rows
            $(document).on("click", "button.buttons-select-all", function (event) {
                event.preventDefault();
                $("#" + id + " tbody tr>td:first-child>input").prop("checked", true);
                var tr_ids = $("#" + id + " tbody tr")
                    .map(function () {
                        return $(this).attr("id");
                    })
                    .get();
                if (!tr_ids) {
                    return;
                }

                window.pw_datatable_selected[id] = tr_ids;

                if (window.pw_datatable_selected[id].length != window.pw_datatable_total_info[id]) {
                    $(".all-rows").show();
                    $(".all-rows").text("Select All " + window.pw_datatable_total_info[id] + " Rows");
                }

                $(this).hide();

                datatablesSelectAll(id, this);
            });

            // select multiple rows even with ajax
            $("#" + id + " tbody").on("click", "tr>td:first-child>input", function (e) {
                e.stopPropagation();
                var tr_id = $(this).closest("tr").attr("id");
                if (!tr_id) {
                    return;
                }
                var index = $.inArray(tr_id, window.pw_datatable_selected[id]);
                if (index === -1) {
                    window.pw_datatable_selected[id].push(tr_id);
                } else {
                    window.pw_datatable_selected[id].splice(index, 1);
                    window.pw_datatable_select_all[id] = false;
                }

                $(this).closest("tr").toggleClass("selected");

                if (window.pw_datatable_selected[id].length == $("#" + id + " tbody tr>td:first-child>input").length) {
                    $("button.buttons-select-all").hide();
                } else {
                    $("button.buttons-select-all").show();
                }

                datatablesSelectAll(id, this);
            });
        });
    }

    function datatablesSelectAll(id, button) {
        if (window.pw_datatable_selected[id].length > 0) {
            var el = $(button).closest(".dataTables_wrapper").find(".unselect-all");
            if (el.length == 0) {
                $(button)
                    .closest(".dataTables_wrapper")
                    .find(".dt-buttons")
                    .prepend(
                        "<button class='unselect-all btn btn-default'><i class='fa fa-minus-square-o'></i> <span class='num'>" +
                            window.pw_datatable_selected[id].length +
                            "</span> selected</button>",
                    );
                el = $(button).closest(".dataTables_wrapper").find(".unselect-all");
                el.on("click", function () {
                    window.pw_datatable_selected[id] = [];
                    window.pw_datatable_select_all[id] = false;
                    $("#" + id + " tbody tr").removeClass("selected");
                    $("#" + id + " tbody tr>td:first-child>input:checked").prop("checked", false);
                    el.remove();
                    $("button.buttons-select-all").show();
                    $(".all-rows").hide();
                });
            }
            if (!window.pw_datatable_select_all[id]) {
                el.find(".num").text(window.pw_datatable_selected[id].length);
            } else {
                el.find(".num").text(window.pw_datatable_total_info[id]);
            }
        } else {
            $(button).closest(".dataTables_wrapper").find(".unselect-all").remove();
        }
    }

    function parseDatatables() {
        $(".datatable").each(function () {
            var order_column = $(this).data("order_column");
            var order_order = $(this).data("order_order");
            var show = $(this).data("show");
            var autowidth = $(this).data("width");

            var aoColumns = [];
            $(this)
                .find("th")
                .each(function () {
                    aoColumns.push({ name: $(this).text(), bSortable: $(this).data("sortable") == "0" ? false : true });
                });

            var params = {
                aoColumns: aoColumns,
                dom: 'fr<"H"l>Btip',
                lengthMenu: [
                    [10, 25, 50, -1],
                    [10, 25, 50, "All"],
                ],
                buttons: [{ extend: "csvHtml5", text: window.pwtrans.table_export_csv }],
                oLanguage: {
                    sUrl: window.location.hostname.lastIndexOf("app.", 0) === 0 ? "" : "/datatables-lang",
                    sEmptyTable: "There's no data to display here yet...",
                },
            };

            if (typeof order_column !== "undefined" && typeof order_order !== "undefined") {
                params.order = [[order_column, order_order]];
            }
            if (typeof show !== "undefined") {
                params.iDisplayLength = show;
            }
            if (typeof autowidth !== "undefined") {
                params.autowidth = autowidth;
            }

            params.responsive = true;

            $(this).DataTable(params);
        });
    }

    function csvButton(e, dt, node, config, aoColumns, dataPath, id) {
        var info = dt.page.info();
        let limit = 1000;
        if (info.recordsTotal > 1000) {
            if (location.href.includes("/admin/")) {
                if (
                    !confirm(
                        "The requested export operation includes more than 1000 records and may be slow or fail. Do you want to limit the result to 1000 records?",
                    )
                ) {
                    limit = 99999999999999;
                }
            } else {
                bootbox.alert(
                    "The requested export operation includes more than 1000 records, which will be limited to 1000 records. For the complete result set, please go to our data export options.",
                );
            }
        }
        var config = config;
        var that = this;
        var ajax = dataPath;
        if (typeof dataPath !== "object") {
            ajax = {
                url: dataPath,
            };
        }
        ajax.url += (ajax.url.indexOf("?") > -1 ? "&" : "?") + `draw=99&start=0&length=${limit}`;
        for (var i in aoColumns) {
            var searchable = false;
            for (var j in aoColumns[i]) {
                if (j == "bSearchable") {
                    searchable = true;
                    ajax.url += "&columns[" + i + "][searchable]=" + aoColumns[i][j];
                } else {
                    ajax.url += "&columns[" + i + "][" + j + "]=" + aoColumns[i][j];
                }
            }
            if (!searchable) {
                ajax.url += "&columns[" + i + "][searchable]=true";
            }
        }
        if (dt.search()) {
            ajax.url += "&search[value]=" + dt.search();
        }
        if (ajax.data) {
            ajax.data.search = $("#search").val();
        } else {
            ajax.data = { search: $("#search").val() };
        }

        var selectedStatusFilters = window.selectedStatusFilters;
        if (selectedStatusFilters !== undefined) {
            ajax.data.status_filter = selectedStatusFilters;
        }

        if (id != "" && !window.pw_datatable_select_all[id]) {
            var true_ids = window.pw_datatable_selected[id];
            true_ids = jQuery.map(true_ids, function (el) {
                return el.replace("dt", "");
            });
            ajax.data.selected = true_ids;
        }

        ajax.success = function (result) {
            var newLine = config.newline ? config.newline : navigator.userAgent.match(/Windows/) ? "\r\n" : "\n";
            config = $.extend(
                true,
                {},
                {
                    rows: null,
                    columns: "",
                    modifier: {
                        search: "applied",
                        order: "applied",
                    },
                    orthogonal: "display",
                    stripHtml: true,
                    stripNewlines: true,
                    decodeEntities: true,
                    trim: true,
                    filename: "*",
                    extension: ".csv",
                    exportOptions: {},
                    fieldSeparator: ",",
                    fieldBoundary: '"',
                    escapeChar: '"',
                    charset: null,
                    header: true,
                    footer: false,
                    format: {
                        header: function (d) {
                            return strip(d);
                        },
                        footer: function (d) {
                            return strip(d);
                        },
                        body: function (d) {
                            return strip(d);
                        },
                    },
                },
                config,
            );

            var strip = function (str) {
                if (typeof str !== "string") {
                    return str;
                }

                // Always remove script tags
                str = str.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");

                if (config.stripHtml) {
                    str = str.replace(/<[^>]*>/g, "");
                }

                if (config.trim) {
                    str = str.replace(/^\s+|\s+$/g, "");
                }

                if (config.stripNewlines) {
                    str = str.replace(/\n/g, " ");
                }

                if (config.decodeEntities) {
                    var _exportTextarea = $("<textarea/>")[0];
                    _exportTextarea.innerHTML = str;
                    str = _exportTextarea.value;
                }

                return str;
            };

            var header = dt
                .columns(config.columns)
                .indexes()
                .map(function (idx) {
                    var el = dt.column(idx).header();
                    return config.format.header(el.innerHTML, idx, el);
                })
                .toArray();

            var footer = dt.table().footer()
                ? dt
                      .columns(config.columns)
                      .indexes()
                      .map(function (idx) {
                          var el = dt.column(idx).footer();
                          return config.format.footer(el ? el.innerHTML : "", idx, el);
                      })
                      .toArray()
                : null;
            var body = result.data;

            var boundary = config.fieldBoundary;
            var separator = config.fieldSeparator;
            var reBoundary = new RegExp(boundary, "g");
            var escapeChar = config.escapeChar !== undefined ? config.escapeChar : "\\";
            var join = function (a) {
                var s = "";

                // If there is a field boundary, then we might need to escape it in
                // the source data
                for (var i = 0, ien = a.length; i < ien; i++) {
                    if (i > 0) {
                        s += separator;
                    }

                    s += boundary ? boundary + ("" + a[i]).replace(reBoundary, escapeChar + boundary) + boundary : a[i];
                }

                return s;
            };

            var header = config.header ? join(header) + newLine : "";
            var footer = config.footer && footer ? newLine + join(footer) : "";
            var rbody = [];

            for (var i = 0, ien = body.length; i < ien; i++) {
                var row = [];
                for (var j in body[i]) {
                    row.push(config.format.body(body[i][j]));
                }
                rbody.push(join(row));
            }

            var output = header + rbody.join(newLine) + footer;
            var info = dt.buttons.exportInfo(config);
            var charset = config.charset;

            if (config.customize) {
                output = config.customize(output, config);
            }

            if (charset !== false) {
                if (!charset) {
                    charset = document.characterSet || document.charset;
                }

                if (charset) {
                    charset = ";charset=" + charset;
                }
            } else {
                charset = "";
            }

            if (config.bom) {
                output = "\ufeff" + output;
            }

            $.fn.dataTable.fileSave(new Blob([output], { type: "text/csv" + charset }), info.filename ? info.filename : document.title + ".csv", true);
        };
        $.ajax(ajax);
    }

    function makeCustomerDataTable(selector, dataPath) {
        $(function () {
            if (dataPath && window.pw_session) {
                dataPath += (dataPath.indexOf("?") > -1 ? "&" : "?") + "_session-token=" + window.pw_session;
            }

            const params = {
                sPaginationType: "full_numbers",
                ajax: dataPath,
                processing: !!dataPath,
                serverSide: !!dataPath,
                stateSave: true,
                responsive: false,
                scrollX: true,
                iDisplayLength: 25,
                ordering: false,
                dom: "trip",
                buttons: [],
                oLanguage: {
                    sUrl:
                        window.location.hostname.lastIndexOf("app.", 0) === 0
                            ? ""
                            : window.pw_session
                            ? "/datatables-lang?_session-token=" + window.pw_session
                            : "/datatables-lang",
                    sEmptyTable: "There's no data to display here yet...",
                },
            };

            $(selector).on("xhr.dt", function (e, ins, json, xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                    return true;
                }
                if (!xhr.responseJSON && json === null && xhr.responseText) {
                    $.ajax({
                        url: "/ajax-error",
                        type: "POST",
                        data: {
                            error: "DataTables invalid JSON response",
                            response: xhr.responseText,
                            status: xhr.status,
                            request_url: dataPath,
                        },
                    });
                }
            });

            $(selector).DataTable(params);
        });
    }

    window.makeDataTable = makeDataTable;
    window.makeCustomerDataTable = makeCustomerDataTable;
    window.parseDatatables = parseDatatables;
})();
